import { render, staticRenderFns } from "./StockDetryComponent.vue?vue&type=template&id=47f04b85"
import script from "./StockDetryComponent.vue?vue&type=script&lang=js"
export * from "./StockDetryComponent.vue?vue&type=script&lang=js"
import style0 from "./StockDetryComponent.vue?vue&type=style&index=0&id=47f04b85&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports